import React from "react"
import { Field } from "formik"

const Input = ({ name, label, className, value, type = "text", ...props }) => {
	return (
		<div className={`w-full ${className || ""}`}>
			<div
				className="flex h-60 w-full flex-col justify-center
			border border-iron focus-within:border-pictonblue hover:border-jetblack hover:focus-within:border-pictonblue
			bg-white px-20 rounded-medium">
				<div className="relative">
					<Field
						id={name}
						name={name}
						placeholder={label}
						className="z-1 peer m-0 mt-[19px] w-full appearance-none border-none bg-transparent p-0 text-base placeholder-transparent outline-none transition-all placeholder-shown:mt-0 focus:mt-[19px] focus:ring-0 focus:ring-offset-0"
					/>
					<label
						htmlFor={name}
						className="transition-all z-1 absolute left-0 m-0 p-0  text-nevada opacity-90 peer-focus:opacity-90 peer-placeholder-shown:opacity-50 text-xs peer-placeholder-shown:text-base peer-focus:text-xs">
						{label}
					</label>
				</div>
			</div>
		</div>
	)
}

export default Input
